export const billingKeys = {
  all: ["billing"] as const,
  status: () => [...billingKeys.all, "status"] as const,
  checkoutSession: (sessionId: string) =>
    [...billingKeys.all, "checkout-session", sessionId] as const,
  invoices: () => [...billingKeys.all, "invoices"] as const,
};
